export default {
  GET_SALES: `#graphql
  query getReportSales($initialDate: Date!, $finalDate: Date!, $brand: String!) {
    getReportSales(initialDate: $initialDate, finalDate: $finalDate, brand: $brand)
    { 
      order,
      status,
      quantitySale,
      dni,
      name,
      phones,
      email,
      address,
      location,
      department,
      methodPay,
      methodPayCost,
      conveyor,
      conveyorCost,
      codeName,
      codeType,
      codePercent,
      codeValue,
      deliveryTime,
      mpCode,
      isWholesaler,
      isDropshipping,
      tip,
      adviser,
      isSale,
      saleByUnit,
      createdAt,
      cart {
        product,
        sizes,
        quantityAvailable,
        quantityCart,
        images,
        priceUnit,
        priceThree,
        priceThreeCommunity,
        priceWholesaler,
        priceSale,
        priceSaleCommunity,
        folder,
        subfolder,
        article,
        design,
        person,
        colors,
        picked,
        tiers,
        isClearence,
        cost,
        appliedPrice,
        productQuantity
      },
    deliveries {
      cost,
      status
    },
    refunds {
      value,
      status
    },
    changes {
      status
    },
    bonuses {
      status,
      originalValue
    },
    payU {
      platform,
      platformUser,
      platformUserName,
      value,
      state
    },
    total,
    quantity
    }
  }`,

  GET_CUSTOMER_METRICS: `#graphql
  query getCustomerMetrics($initialDate: Date!, $finalDate: Date!, $cutoffDate: Date!, $brand: String!) {
    getCustomerMetrics(initialDate: $initialDate, finalDate: $finalDate, cutoffDate: $cutoffDate, brand: $brand)
    {
      newCustomers,
      secondPurchaseCustomers,
      potentiallyLostCustomers,
      totalCustomers,
      oldCustomers,
      totalSales,
      totalOrders
    }
  }`,

  GET_INVOICES: `#graphql
  query getReportInvoices($initialDate: Date!, $finalDate: Date!)  {
    getReportInvoices(initialDate: $initialDate, finalDate: $finalDate)
    { 
      invoice,
      type,
      order,
      status,
      value,
      tax,
      process,
      tascode,
      URL,
      PDF,
      createdBy,
      createdAt
    }            
  }`,

  GET_DELIVERIES: `#graphql
  query getReportDeliveries($initialDate: Date!, $finalDate: Date!, $brand: String!) {
    getReportDeliveries(initialDate: $initialDate, finalDate: $finalDate, brand: $brand)
    {
      orderCreatedAt, 
      delivery,
      order,
      change,
      status,
      charge,
      replacementCharge,
      addressRecipient,
      locationRecipient,
      departmentRecipient,
      nameRecipient,
      addressRecipient,
      phonesRecipient,
      conveyor,
      cost,
      tracking,
      dniDeliveryMan,
      nameDeliveryMan,
      createdBy,
      createdAt,
      deliveredBy,
      deliveredAt,
      inProgressAt,
      inProgressBy,
      declinedAt,
      declinedBy,
      deliveredAt,
      deliveredBy,
      leftBuildingReception,
      paidAt,
      paidBy,
      collectedAt,
      collectedBy,
      type,
      brand
    }        
  }`,

  GET_STOCK_VALUE: `#graphql
  query getReportStockValue($brand: String!) {
    getReportStockValue(brand: $brand)
    {
      totalProducts,
      totalUnit,
      totalWholesaler,
      totalSale,
      totalCost,
      totalsByArticle,
      productsWithZeroCost {
        product,
        article,
        design,
        totalAvailable
      }
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/report.js